const Suppliers = ({ suppliers }) => (
  <div className="px-10 lg:px-20 pt-20 bg-blue-850 h-screen -mb-40 md:-mb-100 lg:-mb-36">
    <h2 className="text-4xl text-white">Our Suppliers</h2>

    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10 md:gap-20 lg:w-11/12 mx-auto mt-10 md:mt-28">
      {suppliers?.map((supplier) => (
        <img
          src={supplier.image}
          alt={supplier.description}
          key={supplier._id}
          className="w-24 h-16 md:w-32 lg:h-20 mx-auto fill-white hover:fill-green-500 hover:scale-125 cursor-pointer transform transition-all duration-200 ease-linear"
        />
      ))}
    </div>
  </div>
);

export default Suppliers;
